module.exports = __webpack_public_path__ + "img/tcApi_step4.cd17fc76.png";